// extracted by mini-css-extract-plugin
export default {"root":"BulkImportInvoicesTable_root__OgV-j"};